import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { Observable } from 'rxjs';

export const LoginGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return !inject(AuthenticationService).checkLogin()
    ? true
    : inject(Router).createUrlTree(['/dashboard/publication']);
};
